import { render } from "./students.vue?vue&type=template&id=078d5bc3"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__